/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
       <el-breadcrumb-item style="cursor:pointer;" @click.native="breadcrumbClick(item.id,index,item)" v-for="(item,index) in breadcrumbList" :key='item.id'>{{item.name}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="breadcrumbList.length==1?true:false">所有</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container class="filter_con">
      <el-header class="fisrtNav">
        <el-row>
          <el-col :span="2">
            <span class="labelTitle" v-if="categorylists.length!=0?true:false">分类：</span>
          </el-col>
          <el-col :span="22" class="labelcontent" >
            <!-- <a
               v-for="(item,index) in categorylists" :key="index"
              style="width: 10%; display: inline-block; margin-bottom: 10px"
              href="https://ceshi.xunyoutest.com?ctl=Product&amp;met=lists&amp;category_id=2267"
              >{{item.name}}
            </a> -->
            <a
              style="width: 10%; display: inline-block; margin-bottom: 10px"
               v-for="(item,index) in categorylists" :key="index"               
               @click="getCategorylist(item.bxscId,item.name)" 
              >{{item.name}}
            </a>

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"> </el-col>
        </el-row>
        <!-- <div class="more_filter">
          <span class="sm_wrap"
            ><em id="sm_txt">查看更多选项</em> <i class="el-icon-arrow-down"></i
          ></span>
        </div> -->
      </el-header>
      <el-container>
        <el-aside width="200px">
          <hotGoods :navTitle="hotGoodsTitle" :hotGoodsList='lefthotGoodsList'></hotGoods>
        </el-aside>
        <el-main class="rightaside">
           <div class="orderby">
            <ul>
              <li :class="isActive==1?'active':''" @click="handleClick(1,'saleNum')">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >热销</a
                >
              </li>
              <li :class="isActive==2?'active':''" @click="handleClick(2,'price')">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >价格 <i class="el-icon-arrow-up"></i
                ></a>
              </li>
              <!-- <li :class="isActive==3?'active':''" @click="handleClick(3)">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >人气</a
                >
              </li> -->
              <li :class="isActive==4?'active':''" @click="handleClick(4,'createTime')">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >上新</a
                >
              </li>
              <!-- <li>
                <el-checkbox
                  v-model="checked1"
                  @change="showLowGoods"
                  label="仅显示特惠商品"
                ></el-checkbox>
              </li>
              <li>
                <el-checkbox
                  v-model="checked2"
                  @change="showHaveGoodList"
                  label="仅显示有货商品"
                ></el-checkbox>
              </li> -->
            </ul>           
          </div>
          <el-row class="right_product" :gutter="20" v-loading="loading">
            <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                ><div class="product_item selectItemCss_ls">
                  <div class="p-img">
                    <router-link
                      :to="`/goodsDetail_supplie?id=${item.id}`"
                      class="item_link"
                    >
                      <el-image
                        class="img-responsive"
                        :src="`${item.photos}`"
                        style="display: block"
                      ></el-image>
                    </router-link>
                  </div>
                  <div class="pro_name">
                    <router-link  :to="`/goodsDetail_supplie?id=${item.id}`">{{item.name}}</router-link>
                  </div>
                  <!-- <div class="profit">利润率：<span>0.20% ~ 50.30%</span></div> -->
                  
                  <div class="pro_price_add">
                    <!-- marketprice 需要乘以折扣 -->
                    <div class="now_price"><i>¥</i><span>{{item.realprice || 0.00}}</span></div> 
                    <div class="cart add-to-cart">
                      <a
                        title="加入购物车"
                        href="javascript:;"
                        data-item_id="1207"
                        @click="addCart(item.id,item.name,item.specificationlist,item.status,item.approvalStatus)"
                        >加入购物车</a
                      >
                    </div>
                  </div>
                </div>
        </el-col>
      </el-row>
          
		  <el-row>
		  	<!-- <div class="nodate" v-if="rightGoodsList.length==0?true:false"> -->
		  	<div class="nodate" v-if="rightGoodsList.length>0?false:true">
		  		<div class="first">对不起，对应商品分类或筛选组合下没有商品!</div>
		  	</div>
		  </el-row>
      <el-row>
          <el-col :span="24" class="pagination">
              <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-col>
        </el-row>
        </el-main>
      </el-container>
    </el-container>

    <!-- 加入购物车弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">已成功加入购物车！</div>
        <div>{{ addGoodsName }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">继续购物</el-button>
          <el-button type="primary" @click="$router.push('/shoppingcart_supplie')"
            >去购物车结算</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import hotGoods from '@/components/hotGoods'
import Pagination from '@/components/Pagination'
import "@/assets/css/base.css";
import { commoditylist,addShoppingCart,categorylist } from "@/api/xunyou";
// import '@/assets/xunyou/css/layui.css'
// import '@/assets/bootstrap.min.csss'
// arr.slice(2,4)
export default {
  data() {
    return {
      isActive:1,
      breadcrumbList:[{id:0,name:'首页',url:'/'}],//面包屑数组
      userInfo: this.$store.state.userInfo,
      loading:false,
      centerDialogVisible: false,
      successInfo: true,
      categorylists:'',
      addGoodsName: "",
      checked1: "",
	    checked2: "",
      rightGoodsList:[],
      hotGoodsTitle:'热卖商品',
      lefthotGoodsList:[
        {
          id:'0',
          price:'1903.88',
          title:'POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫',
          link:'https://ceshi.xunyoutest.com?ctl=Product&amp;met=detail&amp;item_id=1157',
          imgSrc:'https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200721/1595324748630659.jpg!268x268.jpg',
        },
         {
          id:'1',
          price:'1903.88',
          title:'POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫',
          link:'https://ceshi.xunyoutest.com?ctl=Product&amp;met=detail&amp;item_id=1157',
          imgSrc:'https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200721/1595324748630659.jpg!268x268.jpg',
        }, {
          id:'2',
          price:'1903.88',
          title:'POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫',
          link:'https://ceshi.xunyoutest.com?ctl=Product&amp;met=detail&amp;item_id=1157',
          imgSrc:'https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200721/1595324748630659.jpg!268x268.jpg',
        }, {
          id:'3',
          price:'1903.88',
          title:'POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫',
          link:'https://ceshi.xunyoutest.com?ctl=Product&amp;met=detail&amp;item_id=1157',
          imgSrc:'https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200721/1595324748630659.jpg!268x268.jpg',
        },
      ],
       // 请求数据参数
      formInline: {
        pageSize: 12,
        pageNum: 1,
        cid:'',
        stype:1,
        sortway:true    
      },
      // 分页参数
      pageparm:{
        pageSize:12,
        currentPage:1,
        total:0,
      },
    //   items: [
    //     { types: "text", type: "info", label: "热销" },
    //     { types: "text", type: "info", label: "价格" },
    //     { types: "text", type: "info", label: "人气" },
    //     { types: "sort", type: "info", label: "上新" },
    //     { types: "checked", type: "info", label: "仅显示特惠商品" },
    //     { types: "checked", type: "info", label: "仅显示有货商品" },
    //   ],
    };
  },
  // 注册组件
  components: {hotGoods,Pagination},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){      
     if(this.$route.fullPath.indexOf('bxscId')>0){
       let breadObj={
        id:this.$route.query.bxscId,
        name:this.$route.query.bxscName,
        url:`/goodsList?parentBxscId=${this.$route.query.bxscId}`
      }
      this.breadcrumbList.push(breadObj)
      this.getCategorylist(this.$route.query.bxscId)

    }else{
      this.getCommoditylist(this.$route.query.parentBxscId||0,this.$route.query.adWord)
      this.getCategorylist() 
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleClick(index,sortname){
      this.isActive = index
      this.formInline.sortway = !this.formInline.sortway
      this.getCommoditylist('','',sortname)
    },
    // 显示特惠商品
    showLowGoods(){
      if(this.checked1){
        this.checked2 = false
        this.rightGoodsList = []
        this.pageparm.total =0
      }else{
        this.getCommoditylist(this.$route.query.parentBxscId||0,this.$route.query.adWord)
      }      
    },
    // 仅显示有货商品
    showHaveGoodList(){
      if(this.checked2){
        this.checked1 = false
        this.getCommoditylist(this.$route.query.parentBxscId||0,this.$route.query.adWord)
      }
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getCommoditylist()
    },
     // 面包屑点击事件
    breadcrumbClick(id,index,item){
      if(id==0){ // 说明是首页 文字
        this.$router.push('/supplierIndex')
      }
      // let key = this.breadcrumbList.findIndex(v=>v.name==item.name)
      let key = this.breadcrumbList.length-1
      if(index == key){
        return
      }
      this.breadcrumbList.forEach((value,key)=>{
        if(value.id == id){
          this.breadcrumbList = this.breadcrumbList.slice(0,index+1)
          this.getCategorylist(id,'')
        }
      })      
    },

    // 商品列表分类    
    getCategorylist(id,name) {
      // 记录到面包屑数组里
      if(name!=''&&name!=undefined){
        let breadObj={
          id:id,
          name:name,
          url:`/goodsList_supplier?parentBxscId=${id}`
        }
        this.breadcrumbList.push(breadObj)
      }
      categorylist({
        parentBxscId:id||0
      })
        .then((res) => {
          //   if (res.code == 0) {
         this.categorylists = res
         this.getCommoditylist(id)

        })
        .catch((err) => {
          this.$message.error("查询商品分类失败，请稍后再试！");
        });
    },
     // 商品列表查询
    getCommoditylist(id,adWord,sortWay) {
      this.loading = true;
      this.formInline.cid = id || ''
      this.formInline.name = adWord || ''
      this.formInline.sortname = sortWay      
      commoditylist(this.formInline)
        .then((res) => {
          //   if (res.code == 0) {
          this.loading = false;
          if(id==''){
            this.rightGoodsList = res.rows;
            this.pageparm.total = res.total
          }
          // this.rightGoodsList = res.rows;
          this.lefthotGoodsList = res.rows.length>4? res.rows.slice(0,4):res.rows
           // 分页赋值
          this.pageparm.currentPage = this.formInline.pageNum
          this.pageparm.pageSize = this.formInline.pageSize
          // this.pageparm.total = res.total
         
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("查询商品列表失败，请稍后再试！");
        });
    },
    
    addCart(id,name,specificationlist,status,approvalStatus) {
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
        
      if(status==1&&approvalStatus==1){
        addShoppingCart({
        cid: id,
        uid: this.userInfo.userId,   
        number: 1,
        bxysid:0
        // bxysid:specificationlist.length>0?specificationlist[0].bXySid:''
      })
        .then((res) => {
            if (res.code == 0) {            
              console.log("res", res);
              this.addGoodsName = name;
              this.centerDialogVisible = true;
          
            }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("添加购物车失败，请稍后再试！");
        });
      }else{
        this.$message.error('暂时缺货')
				return
      }     
      
    },
  },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.labelTitle {
  text-align: left;
  padding-left: 15px;
  font-weight: bold;
  color: #666;
  font-size: 14px;
}
.labelcontent {
}
.fisrtNav {
  padding: 10px 0px;
  border-top: 1px dashed #ddd;
  border-bottom: 1px dashed #ddd;
  margin-bottom: 20px;
}
.leftaside {
  /* background: pink; */
  /* padding: 10px; */
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
.left_product {
  padding: 10px;
}
.left_product li {
  margin-bottom: 30px;
}
.pro-price {
  margin: 10px 0;
  color: #e4393c;
}
.pro_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  margin: 10px 0;
  height: 40px;
}
.img-responsive {
  /* width: 100%; */
  width: 200px;
  height: 200px;
}
.rightaside {
  /* background: yellow; */
  padding: 0px;
  box-sizing: border-box;
  overflow: hidden;
}
.el-header {
  height: auto !important;
}

/* 右边 */
.orderby {
  width: 100%;
  padding: 8px 0;
  background: #f1f1f1;
}
.orderby ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.orderby ul li {
  background: #fff;
  color: #333;
  margin-left: 10px;
  border: 1px solid #ddd;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 20px;
}
.active {
  background: #ba3232 !important;
  font-weight: bold;
}
.active a {
  color: white !important;
}
.orderby .el-checkbox__label {
  font-size: 12px !important;
}
.orderby .el-checkbox__input {
  vertical-align: bottom !important;
}
.right_product {
  padding: 20px;
  .profit {
    font-size: 14px;
    margin: 10px 0;
    span{
      color: #f12b2d;
    }
} 
}
.right_product .product_item {
  margin-bottom: 20px;
  border: 1px solid #fff;
  border-color: #e9e9e9;
  -webkit-box-shadow: 0 0 2px 2px #f8f8f8;
  box-shadow: 0 0 2px 2px #f8f8f8;
  padding: 10px;
  box-sizing: border-box;
}
.product_item:hover img {
  opacity: 0.7;
}
.pro_price_add {
  display: flex;
  justify-content: space-around;
}
.cart.add-to-cart,
div.now_price {
  flex: 1;
  font-weight: bold;
  border: 1px solid #f12b2d;
  padding: 8px 0;
  text-align: center;
}
/* .cart.add-to-cart:hover{
	border: 1px solid #f12b2d;
} */
div.now_price {
  color: white;
  background: #f12b2d;
  border: 1px solid #f12b2d;
}
.dialog-footer {
  margin-top: 20px;
  display: block;
}
.addGoodsInfo {
  font-size: 24px;
}
.addCartBox .el-button--primary {
  color: #fff;
  background-color: #ff6700;
  border-color: #e65d00;
}

.more_filter {
  width: 100%;
  text-align: center;
  border-top: 1px dashed #ddd;
  margin-top: -1px;
}
.more_filter:hover {
  border-color: #e13c41;
}
.more_filter span {
  display: inline-block;
  height: 30px;
  line-height: 26px;
  margin-top: -1px;
  width: 130px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #fff #ddd #ddd;
  background: #fff;
  font-size: 12px;
  color: #939393;
  cursor: pointer;
}
.filter_con .more_filter span i {
  font-size: 12px;
}
.filter_con .more_filter:hover span {
  color: #e13c41;
  border-color: #fff #e13c41 #e13c41;
}
.nodate{
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}

.pagination{
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #ff6700;
      color: #FFF;
      width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
      background-color: transparent;
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views_supplier/goodsList/index.vue